import { Injectable } from "@angular/core"; 
import { BehaviorSubject, Observable } from "rxjs";
import { BaseService } from "./base.service";
import * as _ from 'lodash';

export enum DISPLAY_SIZE{
    XSS = 'XSS',
    XS = 'XS',
    MD = 'MD',
    LG = 'LG'
}

@Injectable()
export class DisplayService extends BaseService{
    displayState: BehaviorSubject<DISPLAY_SIZE> = new BehaviorSubject(null);

    emitChangeResolution(width: number){
        if(width < 510)
            this.displayState.next(DISPLAY_SIZE.XSS);
        else if(width >= 510 && width < 768)
            this.displayState.next(DISPLAY_SIZE.XS);
        else if(width >= 768 && width < 992)
            this.displayState.next(DISPLAY_SIZE.MD);
        else 
            this.displayState.next(DISPLAY_SIZE.LG);
    }
}